<div class="feed-table-wrapper">
<div class="select-head scrollbar" id="scrollcustom" style="display: flex; flex-direction: column">
     <!-- Industry selection -->
  <div *ngIf="!industryTypes" class="load">Loading feeds details...</div>
  <div class="sensor-outer-container">
    <div class="sensor-outer-wrapper">
      <div class="info-text" style="display: flex; gap: 12px;">
        <p>Select industries to preview feeds</p>
        <div class="sensor-checkbox" style="margin: 0;">
          <span>
            <mat-slide-toggle
              [(ngModel)]="isAllIndustriesChecked"
              (ngModelChange)="onAllIndustryTypesChange($event)"
              class="select-all-toggle"
            >
              <span class="sensor-label cs-lb">Select All</span>
            </mat-slide-toggle>
          </span>
        </div>
      </div>
      <div class="mat-ls">
        <div *ngFor="let industry of industryTypes; let i = index" class="sensor-checkbox">
          <span>
            <mat-checkbox
              [(ngModel)]="industry.selected"
              [checked]="industry.selected"
              (ngModelChange)="industryTypeChange(industry,i); "
            >
              <span class="sensor-label">{{ industry.name }}
                <img *ngIf="industry.description"
                  alt=""
                  [src]="tooltipImagePath"
                  style="margin: 0 0 4px 5px"
                  matTooltip="{{ industry.description }}"
              /></span>
            </mat-checkbox>
          </span>
        </div>
      </div>
    </div>
  
  </div>
  <div class="cs-table">
  <table *ngIf="dataSource.data.length"
    mat-table
    [dataSource]="dataSource"
    matSort
    class="feed-table">

    <ng-container matColumnDef="feed_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        <span matTooltip="The name of the feed delivering decision-ready information that you can attach to an approved satellite with a sensor type before ordering.">Feed name</span>
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.feedName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Description
      </th>
      <td mat-cell *matCellDef="let row"  class="description-col">
        {{ row.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="f1Score">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        <span matTooltip="Represents the accuracy/ recall of the model. For example, a model achieving a score of 0.9 means it misses only 10 out of every 100 actual objects when counting from space. ">F1 score</span>
      </th>
      <td mat-cell *matCellDef="let row"  class="align-item-center">
        {{ row.f1Score }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        <span matTooltip="Cost of inference or model run generating a feed on the entire scene, regardless of size.">Cost</span>
      </th>
      <td mat-cell *matCellDef="let row"  class="align-item-center">
        <span>
          {{ convertCostToPoints(row.cost)}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        <span matTooltip="The feed works on land, water, or both.">Location (land/water/both)</span>
      </th>
      <td mat-cell *matCellDef="let row" class="align-item-center">
        {{ row.location }}
      </td>
    </ng-container>

    <ng-container matColumnDef="supported_sensor_types">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        <span matTooltip="The sensor modality used to train a feed. ">Supported sensor type</span>
      </th>
      <td mat-cell *matCellDef="let row" class="align-item-center">
        {{ row.sensorsType }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>
  </div>
  <app-notask *ngIf="selectedIndustryList.length != 0 && dataSource.data.length === 0" [feeds]=true></app-notask>

 </div>
</div>
